module.exports = __webpack_public_path__ + "assets/img/a1.d2e6cac0.jpg";